import { useEffect, useState } from 'react';

export const useDeviceDetector = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const mobileRegex =
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
    const isMobile = mobileRegex.test(userAgent);
    console.log('Detected device is ', isMobile ? 'Mobile' : 'Desktop');
    setIsMobile(isMobile);
  }, []);

  return { isMobile };
};
